"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledParagraph = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Text = require("../Text/Text");
var StyledParagraph = /*#__PURE__*/(0, _styledComponents.default)(_Text.Text).withConfig({
  displayName: "StyledParagraph",
  componentId: "c11n-8-107-0__sc-e666if-0"
})([""]);
exports.StyledParagraph = StyledParagraph;